const APP_CONFIG = {
    // app specific
    displayName: 'nextjs_template',
    QUERY_PAGE_SIZE: 10,
    timerTick: 30, // seconds
    // generic config
    defaultAnimationDelay: 250, // ms
    defaultListEndReachedThreshold: 0.2,
    delayTextInputDebounce: 250,
    longAnimationDelay: 1000, // ms
    prefixReducer: 'nextjs_template',
    dateFormat: 'MM/dd/yyyy',
    defaultCurrency: {
        symbol: '$',
    },
    // env
    isDev: !process.env.NODE_ENV || process.env.NODE_ENV === 'development',
    isTesting: process.env.NEXT_PUBLIC_TESTING,
    // route
    privateRedirectRoute: '/login',
    publicRedirectRoute: '/dashboard',
    // Paypal
    PAYPAL_API_KEY: process.env.PAYPAL_API_KEY || '',
    PAYPAL_BUYER_COUNTRY: process.env.PAYPAL_BUYER_COUNTRY
        ? { buyerCountry: process.env.PAYPAL_BUYER_COUNTRY }
        : {},
    PAYPAL_DISABLE_FUNDING: process.env.PAYPAL_DISABLE_FUNDING
        ? { disableFunding: process.env.PAYPAL_DISABLE_FUNDING }
        : {},
    GEOLOCATION_PLUGIN_URL:
        process.env.NEXT_PUBLIC_GEOLOCATION_PLUGIN_URL || '',
    BASE_CURRENCY: process.env.NEXT_PUBLIC_BASE_CURRENCY || 'USD',
    CURRENCY_CONVERT_API_KEY: process.env.NEXT_PUBLIC_CURRENCY_CONVERT_API_KEY,
    CURRENCY_CONVERT_URL: process.env.NEXT_PUBLIC_CURRENCY_CONVERT_URL,
    EMAIL_CONTACT: 'support@tubekick.co',
    EVENT_CONCONVERSION:
        process.env.NEXT_PUBLIC_EVENT_CONCONVERSION || 'createOrderPage',
    YOUTUBE_EVENT_CONVERSION: 'youtube_purchase',
    TIKTOK_EVENT_CONVERSION: 'tiktok_checkout_purchase',
    GA_CATEGORY: process.env.NEXT_PUBLIC_GA_CATEGORY || 'ga_purchase',
    SECRET_KEY_HMAC: process.env.NEXT_PUBLIC_SECRET_KEY_HMAC,
    SITE_URL: process.env.NEXT_PUBLIC_SITE_URL,
    IPAYTOTAL_KEY: process.env.NEXT_PUBLIC_IPAYTOTAL_KEY,
    CARDINITY_NOTIFICATION_URL:
        process.env.NEXT_PUBLIC_CARDINITY_NOTIFICATION_URL,
    regexIsUrl:
        /((http(?:s?))?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi,
    /* eslint-enable */
    MOBILE_WIDTH: 767,
    YOUTUBE: {
        DEFAULT_URL: 'https://www.youtube.com/watch?v=',
        DEFAULT_CHANNEL: 'https://www.youtube.com/channel/',
        SEARCH_URL: 'https://www.googleapis.com/youtube/v3/search',
        VIDEOS_URL: 'https://www.googleapis.com/youtube/v3/videos',
        CHANNEL_URL: 'https://www.googleapis.com/youtube/v3/channels',
    },
    YOUTUBE_RANGES: {
        views: {
            min: [0, 1000],
            '10%': [1000, 500],
            '20%': [2000, 1000],
            '40%': [4000, 1000],
            '60%': [10000, 1000],
            max: [20000],
        },
        likes: {
            min: [0, 100],
            '15%': [100, 10],
            '50%': [500, 50],
            // '70%': [2000, 100],
            max: [2000],
        },
        subscribers: {
            min: [0, 80],
            '20%': [80, 10],
            '60%': [200, 20],
            max: [500],
        },
        shares: {
            min: [0, 750],
            '10%': [750, 50],
            '20%': [1000, 100],
            '40%': [4000, 500],
            '60%': [10000, 1000],
            '70%': [30000, 2000],
            max: [50000],
        },
        watchhours: {
            min: [0, 100],
            '10%': [100, 150],
            '20%': [250, 250],
            '30%': [500, 500],
            max: [4000],
        },
        dedicatedComments: {
            min: [0, 10],
            '15%': [10, 2],
            '30%': [40, 2],
            max: [100],
        },
    },
    YOUTUBE_PRICES: {
        views: 0.004,
        likes: 0.035,
        subscribers: 0.06,
        dedicatedComments: 0.203,
        shares: 0.0035,
    },
    TWITTER: {
        regexVideo: /http(?:s)?:\/\/(?:www\.)?twitter\.com\/([a-zA-Z0-9_]+)/,
        PRICES: {
            followers: 0.004,
            likes: 0.035,
        },
        DEFAULT_VALUE: {
            follower: {
                price: 3.98,
                quantity: 500,
                discount: 0.02,
            },
            like: {
                price: 3.49,
                quantity: 50,
                discount: 0.01,
            },
        },
        SLIDE_RANGE: {
            followers: {
                min: [0, 500],
                '10%': [500, 500],
                '20%': [1000, 1000],
                '40%': [4000, 1000],
                '60%': [10000, 1000],
                max: [20000],
            },
            likes: {
                min: [0, 50],
                '15%': [50, 10],
                '50%': [500, 50],
                '70%': [2000, 100],
                max: [10000],
            },
        },
        ACCEPT_URLS: [
            '/twitter/create-order',
            '/twitter/complete-order',
            '/twitter/select-post',
        ],
    },
    FACEBOOK: {
        /*eslint-disable */
        regexUrl:
            /^(?:https?:\/\/)(?:www\.|m\.|mobile\.|touch\.|mbasic\.)?(?:facebook\.com|fb(?:\.me|\.com))\/(?!$)(?:(?:\w)*#!\/)?(?:pages\/)?(?:photo\.php\?fbid=)?(?:[\w\-]*\/)*?(?:\/)?(?:profile\.php\?id=)?([^\/?&\s]*)(?:\/|&|\?)?.*$/,
        PRICES: {
            followers: 0.034,
            likes: 0.035,
        },
        SLIDE_RANGE: {
            followers: {
                min: [0, 500],
                '10%': [500, 500],
                '20%': [1000, 1000],
                '40%': [4000, 1000],
                '60%': [10000, 1000],
                max: [20000],
            },
            likes: {
                min: [0, 50],
                '15%': [50, 10],
                '50%': [500, 50],
                '70%': [2000, 100],
                max: [10000],
            },
            user_follower: {
                min: [0, 500],
                '10%': [500, 500],
                '20%': [1000, 1000],
                '40%': [4000, 1000],
                '60%': [10000, 1000],
                max: [20000],
            },
        },
        /* eslint-enable */
    },
    TIKTOK: {
        regexUrl:
            /http(?:s?):\/\/(?:www|m|[a-z]{1,})\.(tiktok\.com)\/?(@([\w]+))?(?:v|video|embed|trending|share)?(?:\/)?(?:video)?(?:\/)?(?:\?shareId=)?(?:user)?(?:\/)?([\d]+)?/,
        regexUsername:
            /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/,
        DEFAULT_VALUE: {
            follower: {
                price: 6.27,
                quantity: 500,
                discount: 0.06,
                // price: 0,
                // quantity: 0,
                // discount: 0,
            },
            like: {
                // price: 0,
                // quantity: 0,
                // discount: 0,
                price: 5.42,
                quantity: 800,
                discount: 0.08,
            },
            view: {
                // price: 0,
                // quantity: 0,
                // discount: 0,
                price: 5.4,
                quantity: 25000,
                discount: 0.1,
            },
            comment: {
                price: 12.9,
                quantity: 100,
                discount: 0.28,
            },
            share: {
                price: 3.9,
                quantity: 300,
                discount: 0.04,
            },
        },
        PRICES: {
            followers: 0.006325,
            likes: 0.0034375,
            views: 0.00011,
            comment: 0.129,
        },
        SLIDE_RANGE: {
            followers: {
                min: [0, 500],
                '10%': [500, 100],
                max: [10000],
            },
            likes: {
                min: [0, 800],
                '10%': [800, 100],
                max: [10000],
            },
            views: {
                min: [0, 4000],
                '10%': [4000, 1000],
                '60%': [25000, 1000],
                max: [40000],
            },
            shares: {
                min: [0, 100],
                '5%': [100, 100],
                max: [10000],
            },
            comments: {
                min: [0, 50],
                '10%': [50, 10],
                max: [500],
            },
        },
        ACCEPT_URLS: [
            '/tiktok/create-order',
            '/tiktok/complete-order',
            '/tiktok/select-post',
        ],
        PRICE_RANGE: {
            share: {
                0: {
                    price: 0,
                    discount: 0,
                },
                100: {
                    price: 1.99,
                    discount: 0,
                },
                300: {
                    price: 3.9,
                    discount: 34.67,
                },
                500: {
                    price: 5.95,
                    discount: 40.2,
                },
                1000: {
                    price: 9.95,
                    discount: 50,
                },
                1500: {
                    price: 13.95,
                    discount: 53.27,
                },
                2500: {
                    price: 22.95,
                    discount: 53.87,
                },
                5000: {
                    price: 44.95,
                    discount: 54.82,
                },
                7500: {
                    price: 59.95,
                    discount: 59.83,
                },
                10000: {
                    price: 69.95,
                    discount: 64.85,
                },
            },
            comment: {
                0: {
                    price: 0,
                    discount: 0,
                },
                50: {
                    price: 8.9,
                    discount: 0,
                },
                60: {
                    price: 10.15,
                    discount: 5,
                },
                70: {
                    price: 11.25,
                    discount: 9.78,
                },
                80: {
                    price: 12.21,
                    discount: 14.26,
                },
                90: {
                    price: 13.05,
                    discount: 18.55,
                },
                100: {
                    price: 13.77,
                    discount: 22.62,
                },
                110: {
                    price: 14.39,
                    discount: 26.49,
                },
                120: {
                    price: 14.92,
                    discount: 31.17,
                },
                130: {
                    price: 15.35,
                    discount: 33.66,
                },
                140: {
                    price: 15.71,
                    discount: 36.98,
                },
                150: {
                    price: 15.99,
                    discount: 40.13,
                },
                160: {
                    price: 16.2,
                    discount: 43.12,
                },
                170: {
                    price: 16.35,
                    discount: 45.96,
                },
                180: {
                    price: 16.45,
                    discount: 48.67,
                },
                190: {
                    price: 16.49,
                    discount: 51.23,
                },
                200: {
                    price: 17.19,
                    discount: 51.72,
                },
                210: {
                    price: 17.87,
                    discount: 52.2,
                },
                220: {
                    price: 18.53,
                    discount: 52.68,
                },
                230: {
                    price: 19.18,
                    discount: 53.15,
                },
                240: {
                    price: 19.81,
                    discount: 53.62,
                },
                250: {
                    price: 20.43,
                    discount: 50.09,
                },
                260: {
                    price: 21.04,
                    discount: 54.55,
                },
                270: {
                    price: 21.63,
                    discount: 55,
                },
                280: {
                    price: 22.2,
                    discount: 55.45,
                },
                290: {
                    price: 22.77,
                    discount: 55.9,
                },
                300: {
                    price: 23.2,
                    discount: 56.56,
                },
                310: {
                    price: 23.61,
                    discount: 57.21,
                },
                320: {
                    price: 24.01,
                    discount: 57.85,
                },
                330: {
                    price: 34.39,
                    discount: 58.48,
                },
                340: {
                    price: 24.75,
                    discount: 59.11,
                },
                350: {
                    price: 25.1,
                    discount: 59.72,
                },
                360: {
                    price: 25.42,
                    discount: 60.32,
                },
                370: {
                    price: 25.74,
                    discount: 60.92,
                },
                380: {
                    price: 26.04,
                    discount: 61.5,
                },
                390: {
                    price: 26.32,
                    discount: 62.08,
                },
                400: {
                    price: 26.59,
                    discount: 62.65,
                },
                410: {
                    price: 26.85,
                    discount: 63.21,
                },
                420: {
                    price: 27.09,
                    discount: 63.76,
                },
                430: {
                    price: 27.32,
                    discount: 64.31,
                },
                440: {
                    price: 27.54,
                    discount: 62.58,
                },
                450: {
                    price: 27.74,
                    discount: 65.37,
                },
                460: {
                    price: 27.93,
                    discount: 65.89,
                },
                470: {
                    price: 28.11,
                    discount: 66.4,
                },
                480: {
                    price: 28.28,
                    discount: 66.9,
                },
                490: {
                    price: 28.43,
                    discount: 67.4,
                },
                500: {
                    price: 28.58,
                    discount: 67.89,
                },
            },
        },
    },
    FACEBOOK_PRICES: {
        followers: 0.015,
        likes: 0.0111,
        user_follower: 0.015,
    },
    FACEBOOK_RANGES: {
        followers: {
            min: [0, 250],
            '10%': [500, 50],
            '20%': [1000, 100],
            // '40%': [2000, 100],
            '60%': [5000, 100],
            max: [10000],
        },
        likes: {
            min: [0, 250],
            '10%': [500, 50],
            '20%': [1000, 100],
            '60%': [5000, 200],
            max: [10000],
        },
        user_follower: {
            min: [0, 250],
            '10%': [500, 50],
            '20%': [1000, 100],
            // '40%': [2000, 100],
            '60%': [5000, 100],
            max: [10000],
        },
    },
    FACEBOOK_DEFAULT_PRICES: {
        follower: {
            price: 7.42,
            quantity: 250,
            discount: 0.07,
            // price: 0,
            // quantity: 0,
            // discount: 0,
        },
        like: {
            price: 5.5,
            quantity: 250,
            discount: 0.05,
            // price: 0,
            // quantity: 0,
            // discount: 0,
        },
        user_follower: {
            price: 7.42,
            quantity: 250,
            discount: 0.07,
            // price: 0,
            // quantity: 0,
            // discount: 0,
        },
    },
    TIKTOK_PRICES: {
        followers: 0.004,
        likes: 0.035,
        share: 0.0199,
        comment: 0.178,
    },
    IPAY88: {
        PAYMENT_LINK: process.env.IPAY88_PAYMENT_LINK,
        MERCHANT_CODE: process.env.IPAY88_MERCHANT_CODE,
        MERCHANT_KEY: process.env.IPAY88_MERCHANT_KEY,
        PAYMENT_ID: process.env.IPAY88_PAYMENT_ID,
        CURRENCY: process.env.IPAY88_CURRENCY,
        SIGNATURE_TYPE: process.env.IPAY88_SIGNATURE_TYPE,
        // BACKEND_URL: `${process.env.NEXT_PUBLIC_API_BASE_URL}v1/complete-order`,
        BACKEND_URL: `${process.env.NEXT_PUBLIC_API_BASE_URL}order/ipay88_complete`,
        RESPONSE_URL: `${process.env.NEXT_PUBLIC_SITE_URL}/complete-order`,
    },
    STRIPE: {
        REDIRECT_URL: process.env.NEXT_PUBLIC_REDIRECT_URL,
    },
    MAX_AMOUNT: 350,
    getMessageOverAmount(): string {
        return `Due to the high demand, orders can currently not exceed $${this.MAX_AMOUNT}`;
    },
};

export default APP_CONFIG;

export const GTM_ID = 'GTM-WG9VBGL';

export const ORDER_INPROGRESS_MESSAGE =
    'Some of your videos still have orders in progress. Please try again later. ';

export const HOME_PATHS = ['instagram', 'tiktok', 'twitch', 'twitter'];

export const LIST_ICONS_IMAGE = [
    {
        link: '/youtube',
        img: '/images/icons/youtube.png',
        width: 76,
        height: 18,
        desktop: {
            width: 74,
            height: 20,
        },
    },

    {
        link: '/tiktok',
        img: '/images/icons/tiktok.png',
        width: 61,
        height: 18,
        desktop: {
            width: 68,
            height: 20,
        },
    },

    {
        link: '/twitch',
        img: '/images/icons/twitch.png',
        width: 54,
        height: 18,
        desktop: {
            width: 60,
            height: 20,
        },
    },

    {
        link: '/instagram',
        img: '/images/icons/instagram.png',
        width: 84,
        height: 18,
        desktop: {
            width: 94,
            height: 20,
        },
    },

    {
        link: '/twitter',
        img: '/images/icons/twitter.png',
        width: 76,
        height: 18,
        class: 'h-8 cursor-pointer',
        desktop: {
            width: 75,
            height: 20,
        },
    },
];

export const LANDING_PAGE_URL = process.env.NEXT_PUBLIC_LANDING_URL;

export const DOMAIN_SITE = 'tubekick';

export const DISABLED_UPSELL_NEXT_POST =
    process.env.NEXT_PUBLIC_DISABLED_UPSELL_NEXT_POST === 'true';
